import { cn } from "src/core/lib/utils";

type SpinnerProps = {
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
} & React.HTMLAttributes<HTMLDivElement>;

const sizeClasses = {
  sm: "w-4 h-4",
  md: "w-6 h-6",
  lg: "w-8 h-8",
  xl: "w-10 h-10",
  "2xl": "w-12 h-12",
};

export function Spinner({ className, size = "md", ...props }: SpinnerProps) {
  return (
    <div
      role="status"
      className={cn(
        "animate-spin rounded-full border-2 border-current border-t-transparent",
        sizeClasses[size],
        className
      )}
      {...props}
    />
  );
}
